// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__FXNs5","rotate":"Spinner_rotate__Nveyw","prixClipFix":"Spinner_prixClipFix__oPeqA"};